import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchJoinableLeagues } from '@/lib/network/leagues';

export const JOINABLE_LEAGUES_PAGE_SIZE = 20;

export const useJoinableLeagues = (isCelebrity?: boolean) =>
  useInfiniteQuery({
    queryKey: ['leagues', 'joinable', isCelebrity ?? 'all'],
    queryFn: ({ pageParam }) =>
      fetchJoinableLeagues({
        page: pageParam,
        limit: JOINABLE_LEAGUES_PAGE_SIZE,
        isCelebrity,
      }),
    initialPageParam: 1,
    getNextPageParam: lastPage => {
      const { page, totalPages } = lastPage.data.pagination;
      return page < totalPages ? page + 1 : undefined;
    },
  });
